var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSheetStampSnapshotGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.68 50.9399H42.5601V113.85H126.68V50.9399Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 35.27C10.0013 33.5365 10.344 31.8203 11.0086 30.2193C11.6732 28.6183 12.6466 27.1639 13.8733 25.9391C15.0999 24.7143 16.5558 23.7431 18.1578 23.0809C19.7598 22.4188 21.4766 22.0787 23.21 22.08C25.4504 22.0752 27.6544 22.6469 29.61 23.74V105.35C27.6544 104.257 25.4504 103.685 23.21 103.69C21.4766 103.689 19.7598 104.029 18.1578 104.691C16.5558 105.353 15.0999 106.324 13.8733 107.549C12.6466 108.774 11.6732 110.228 11.0086 111.829C10.344 113.43 10.0013 115.147 10 116.88V35.27Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.61 92.47C106.7 93.33 107.52 93.8899 108.61 93.8899C109.7 93.8899 110.46 93.33 110.46 92.55C110.46 91.77 110 91.47 109 91.19L108 90.9299C106.54 90.5599 105.89 89.9299 105.89 88.8399C105.89 87.5199 107.05 86.5999 108.69 86.5999C109.021 86.5612 109.356 86.5895 109.675 86.683C109.994 86.7766 110.292 86.9334 110.549 87.1443C110.807 87.3552 111.019 87.6158 111.174 87.9106C111.329 88.2053 111.423 88.5282 111.45 88.86H110.45C110.423 88.6513 110.355 88.4501 110.249 88.2679C110.144 88.0858 110.003 87.9264 109.836 87.799C109.669 87.6716 109.478 87.5786 109.274 87.5256C109.07 87.4725 108.858 87.4604 108.65 87.4899C107.65 87.4899 106.91 88.02 106.91 88.79C106.91 89.39 107.35 89.7899 108.42 90.0299L109.25 90.2499C110.89 90.6599 111.56 91.2499 111.56 92.4299C111.56 93.8799 110.42 94.7799 108.56 94.7799C106.88 94.7799 105.72 93.87 105.63 92.47H106.61Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.58 83.11V49.13",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3198 79.61H101.43",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5698 79.61H49.2398",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.58 115.12V106.02",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.86 99.95C114.057 99.95 118.27 95.737 118.27 90.54C118.27 85.343 114.057 81.13 108.86 81.13C103.663 81.13 99.4502 85.343 99.4502 90.54C99.4502 95.737 103.663 99.95 108.86 99.95Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0602 82.92C53.0418 82.92 52.0651 82.5154 51.3449 81.7953C50.6248 81.0751 50.2202 80.0984 50.2202 79.08C50.2202 78.0616 50.6248 77.0848 51.3449 76.3647C52.0651 75.6446 53.0418 75.24 54.0602 75.24",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0601 72.94C53.0769 72.8898 52.1505 72.4638 51.4723 71.7501C50.7942 71.0364 50.416 70.0895 50.416 69.105C50.416 68.1205 50.7942 67.1736 51.4723 66.4599C52.1505 65.7462 53.0769 65.3202 54.0601 65.27",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.46 65.27C83.4432 65.3202 84.3696 65.7462 85.0478 66.4599C85.7259 67.1736 86.1041 68.1205 86.1041 69.105C86.1041 70.0895 85.7259 71.0364 85.0478 71.7501C84.3696 72.4638 83.4432 72.8898 82.46 72.94",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.46 75.24C83.4784 75.24 84.4551 75.6446 85.1753 76.3647C85.8954 77.0848 86.3 78.0616 86.3 79.08C86.3 80.0984 85.8954 81.0751 85.1753 81.7953C84.4551 82.5154 83.4784 82.92 82.46 82.92",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0601 65.2699C54.0601 64.2515 54.4646 63.2748 55.1848 62.5546C55.9049 61.8345 56.8816 61.4299 57.9001 61.4299C58.9185 61.4299 59.8952 61.8345 60.6153 62.5546C61.3355 63.2748 61.7401 64.2515 61.7401 65.2699",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0001 65.27C63.9736 64.7499 64.0531 64.2299 64.2338 63.7415C64.4145 63.2531 64.6927 62.8065 65.0514 62.429C65.4102 62.0515 65.8419 61.7509 66.3205 61.5455C66.799 61.3401 67.3143 61.2341 67.8351 61.2341C68.3559 61.2341 68.8712 61.3401 69.3498 61.5455C69.8283 61.7509 70.2601 62.0515 70.6188 62.429C70.9775 62.8065 71.2557 63.2531 71.4365 63.7415C71.6172 64.2299 71.6967 64.7499 71.6701 65.27",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0001 65.27C73.9736 64.7499 74.0531 64.2299 74.2338 63.7415C74.4145 63.2531 74.6927 62.8065 75.0514 62.429C75.4102 62.0515 75.8419 61.7509 76.3205 61.5455C76.799 61.3401 77.3143 61.2341 77.8351 61.2341C78.3559 61.2341 78.8712 61.3401 79.3498 61.5455C79.8283 61.7509 80.2601 62.0515 80.6188 62.429C80.9775 62.8065 81.2557 63.2531 81.4365 63.7415C81.6172 64.2299 81.6967 64.7499 81.6701 65.27",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.69 82.9199C81.6398 83.9032 81.2138 84.8295 80.5001 85.5077C79.7864 86.1859 78.8395 86.564 77.855 86.564C76.8705 86.564 75.9236 86.1859 75.2099 85.5077C74.4962 84.8295 74.0702 83.9032 74.02 82.9199",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.71 82.9199C71.6598 83.9032 71.2339 84.8295 70.5202 85.5077C69.8065 86.1859 68.8596 86.564 67.875 86.564C66.8905 86.564 65.9436 86.1859 65.2299 85.5077C64.5162 84.8295 64.0903 83.9032 64.04 82.9199",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7401 82.9199C61.7401 83.9384 61.3355 84.9151 60.6153 85.6352C59.8952 86.3554 58.9185 86.7599 57.9001 86.7599C56.8816 86.7599 55.9049 86.3554 55.1848 85.6352C54.4646 84.9151 54.0601 83.9384 54.0601 82.9199",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.39 37H140V127.94H23.49C20.2384 127.94 17.12 126.648 14.8209 124.349C12.5217 122.05 11.23 118.932 11.23 115.68",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3198 87.3699V69.6899H101",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M101 118.12H83.3198V100.44",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M131.75 100.44V118.12H114.07",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M114.07 69.6899H131.75V87.3699",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheetStampSnapshotGrey);
export default __webpack_public_path__ + "static/media/sheet_stamp_snapshot_grey.dbf4d56d0b94247450b79e3d2f2fcb36.svg";
export { ForwardRef as ReactComponent };